(function () {
  "use strict";

  var root = document.querySelector(".cc-contact-ultimate[data-cc-shopify-native]");
  var form = root && root.querySelector("#CCContactForm");
  if (!root || !form || root.dataset.ccContactReady === "true") return;
  root.dataset.ccContactReady = "true";

  var result = form.querySelector("[data-cc-form-result]");
  if (result) result.focus();

  var subject = form.querySelector("#ccu-subject");
  var status = root.querySelector("#ccu-route-status");

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function scrollToForm(focusField) {
    form.scrollIntoView({ behavior: prefersReducedMotion() ? "auto" : "smooth", block: "center" });
    if (focusField) window.setTimeout(function () { focusField.focus(); }, prefersReducedMotion() ? 0 : 450);
  }

  root.querySelectorAll("[data-ccu-scroll]").forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      scrollToForm(form.querySelector("#ccu-name"));
    });
  });

  root.querySelectorAll("[data-ccu-scroll-to-form]").forEach(function (button) {
    button.setAttribute("aria-controls", "CCContactForm");
    button.addEventListener("click", function () {
      root.querySelectorAll("[data-ccu-scroll-to-form]").forEach(function (candidate) {
        candidate.setAttribute("aria-pressed", candidate === button ? "true" : "false");
      });
      var value = button.getAttribute("data-ccu-value") || "General question";
      if (subject) subject.value = value;
      if (status) status.textContent = value + " selected. The message form is ready.";
      scrollToForm(form.querySelector("#ccu-message"));
    });
  });
})();
